import React, { useMemo, useEffect } from 'react';
import { Grid, Paper, Card, CardContent, Typography, Divider } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import moment from 'moment';
import { liveTrackinglayoutSelector } from '../../../features/layout/layoutSlice';
import { useSelector } from 'react-redux';
import { useTable } from 'react-table';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useTheme } from '@mui/material/styles';
import { renderAddressMapLink } from './reportMapLinks';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: 'Silver',
        color: useTheme().palette.common.black,
        fontSize: 13,
        fontStyle: 'bold'
    },
    body: {
        fontSize: 13,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: useTheme().palette.action.hover,
        },
    },
}))(TableRow);

/*
time: ev.eventTime,
            assetName: reportSummary.assetName,
            tankName: ev.fuel_event_tankName,
            volume: ev.fuel_event_volume,
            event_type: ev.fuel_event_type,
            lat: ev.lat,
            lng: ev.lng
*/
const FuelFillnTheft = ({ reportData }) => {
    const dimentions = useSelector(liveTrackinglayoutSelector);
    const tableData = useMemo(() => {
        if (reportData.reportRecords && reportData.reportRecords.length > 0) {
            //console.log("Filln", reportData.reportRecords);
            return reportData.reportRecords.map(item => {
                return {
                    vehicle: item.assetName,
                    tank: item.tankName,
                    activity: item.event_type.toUpperCase(),
                    time: moment(item.time).format('D/M/Y hh:mm A'),
                    volume: `${item.volume} L`,
                    key: item.assetName,
                    address: item.address ? item.address.net_addr : '',
                    startVol: `${item.startVol} L`,
                    endVol: `${item.endVol} L`,
                    gmap: renderAddressMapLink({
                        address: item.address,
                        lat: item.lat,
                        lng: item.lng,
                    }),
                };
            })
        } else {
            return [];
        }
    }, [reportData]);


    const tableColumns = useMemo(() => {
        return [
            { Header: 'Vehicle', accessor: 'vehicle' },
            { Header: 'Tank', accessor: 'tank' },
            { Header: 'Activity', accessor: 'activity' },
            { Header: 'Time', accessor: 'time' },
            { Header: 'Before', accessor: 'startVol' },
            { Header: 'Quantity', accessor: 'volume' },
            { Header: 'After', accessor: 'endVol' },
            { Header: 'Location', accessor: 'gmap' },
        ];
    }, []);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns: tableColumns, data: tableData });


    if (reportData && reportData.reportRecords && reportData.reportRecords.length > 0) {
        return (
            <Paper style={{ ...dimentions.reportDetailViewBottom, overflow: 'auto' }}>
                <div style={{ margin: '10px' }}>
                    <Grid container spacing={1}>
                        <Grid item container sm={12}>
                            <Card style={{ backgroundColor: 'White', width: '100%' }} variant="outlined">
                                <CardContent>
                                    <Typography variant="h6" style={{ color: 'RoyalBlue' }}><b>Report Summary</b></Typography>
                                    <Divider />
                                    <br />
                                    <Grid container>
                                        <Grid item sm={2}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                From
                                            </Typography>
                                        </Grid>
                                        <Grid item sm={10}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                {`${moment(reportData.reqBody.timeFrom).format('Do MMM YY hh:mm A')}`}
                                            </Typography>

                                        </Grid>
                                        <Grid item sm={2}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                To
                                            </Typography>
                                        </Grid>
                                        <Grid item sm={10}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                {`${moment(reportData.reqBody.timeTo).format('Do MMM YY hh:mm A')}`}
                                            </Typography>

                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item sm={12} container>
                            <TableContainer component={Paper}>
                                <Table  {...getTableProps()}>
                                    <TableHead>
                                        {headerGroups.map(headerGroup => (
                                            <TableRow {...headerGroup.getHeaderGroupProps()}>
                                                {headerGroup.headers.map(column => (
                                                    <StyledTableCell
                                                        {...column.getHeaderProps()}
                                                    >
                                                        <b>{column.render('Header')}</b>
                                                    </StyledTableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableHead>
                                    <TableBody {...getTableBodyProps()}>
                                        {rows.map((row) => {
                                            prepareRow(row)
                                            return (
                                                <StyledTableRow {...row.getRowProps()}>
                                                    {row.cells.map(cell => {
                                                        return (
                                                            <StyledTableCell
                                                                {...cell.getCellProps()}
                                                            >
                                                                {cell.render('Cell')}
                                                            </StyledTableCell>
                                                        )
                                                    })}
                                                </StyledTableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </div>
            </Paper>
        );
    } else {
        return null;
    }
}

export default FuelFillnTheft;
